"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (namespace) => {
    const actionNames = [
        'PREVALIDATE_FILES_REQUEST',
        'PREVALIDATE_FILES_SUCCESS',
        'PREVALIDATE_FILES_FAILURE',
        'PREVALIDATE_IMPORTED_FILES_REQUEST',
        'PREVALIDATE_IMPORTED_FILES_SUCCESS',
        'PREVALIDATE_IMPORTED_FILES_FAILURE',
        'SELECT_FILES',
        'UNSELECT_FILES',
        'REMOVE_FILE',
        'RESTORE_FILE',
        'CHANGE_COLOR',
        'BROWSE'
    ];
    const actionTypes = actionNames.reduce((acc, action) => {
        acc[action] = `@sok/modules/orderFiles/${namespace}/${action}`;
        return acc;
    }, {});
    return actionTypes;
};
//# sourceMappingURL=actionTypes.js.map